import { apiClient } from "../config";

async function editLayerForAdmin(geographyId: string, data: any) {
  const url = `/admin/geographies/${geographyId}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editLayerForAdmin;
